let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6AYT8")).then(() => parcelRequire('bKcVz'));